<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-6 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <v-spacer></v-spacer>
                  <h1 class="text-md-center">Nelson Chat-Verlauf</h1>
                </div>
                <v-form>
                  <v-text-field append-icon="person" name="login" label="Benutzername" type="text" @keyup.enter="login" v-model="model.email"></v-text-field>
                  <v-text-field append-icon="lock" name="password" label="Passwort" id="password" type="password"  @keyup.enter="login" v-model="model.password"></v-text-field>
                  <v-checkbox id="my-checkbox" v-model="isAdmin" label="Is Admin" inline></v-checkbox>      
                  
                  <v-text-field v-if="isAdmin" append-icon="lock" name="token" label="Token" type="text" @keyup.enter="login" v-model="model.token"></v-text-field>

                </v-form>
                <div v-if="error" class="v-alert v-alert--outline error--text" style="background-color: #e20074;">
                  <div >
                    <p style="color:white;font-size:20px">{{error}}</p>
                  </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-flex mt-2>
                  <v-btn block color="primary" @click="login" :loading="loading">Login</v-btn>
                </v-flex>
              </v-card-actions>
              <v-card-actions>
                <v-flex mt-2>
                  <a href="#/register"  @click="register">Register</a>
                </v-flex>
                <v-flex mt-2>
                  <a href="#/changePassword"  @click="changePassword">Forgot password</a>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import API from '@/api'
import colors from '../theme/colors'

export default {
  data: () => ({
    error: '',
    loading: false,
    isAdmin: false,
    model: {
      email: '',
      token: '',
      password: ''
    }
  }),

  methods: {
    /**
     * Sends request to backend.
     * Sets theme and jwt token in local browser storage if successful.
     * Redirects to chat window
     */
    onEnterClick: function() {
    	alert('Enter was pressed');
    },
    async login () {
      this.loading = true
      try {
        const data = {
          email: this.model.email,
          token: this.model.token,
          password: this.model.password
        }
        const response = await API.login(data)
        if (response.message && response.message === 'disabled') {
          this.error = 'User is disabled!'
          this.loading = false
        } else {
          this.$store.commit('updateToken', response.token)
          this.$store.commit('setTheme', response.brand)
          this.$store.commit('setRole', response.role)
          localStorage.setItem("role", response.role)
          this.loading = false
          this.model.email = ''
          this.model.password = ''
          this.model.token = ''
          this.error = ''
          if (response.reset) {
            this.$router.push('/users/manageUsers/' + response.email + '/change=true')
          } else {
            this.$router.push('/chat')
          }
        }
      } catch (err) {
        this.error = 'Wrong password or login!'
        this.loading = false
      }
    },
     async register () {
      var url = window.location.origin;
      console.log(url)
      url = url + "#/register";  // this number is dynamic actually
      window.location.href = url;
      window.location.reload();
     },
     async changePassword () {
      var url = window.location.origin;
      console.log(url)
      url = url + "#/changePassword";  // this number is dynamic actually
      window.location.href = url;
      window.location.reload();
     }
  },
  beforeCreate () {
    // make sure old settings are removed
    this.$store.commit('removeToken')
    this.$store.commit('removeTheme')
  }
}
</script>
<style scoped lang="css">
  #login {
    color:#223056!important;
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
